import * as AppPics from 'assets/images';
function Html() {
  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <ul className="tab__menu">
          <li className="active">Recent Courses</li>
          <li>All Courses</li>
          <li>Draft Courses</li>
          <li>Deactivated</li>
          <li>Archived</li>
        </ul>
        <div className="tab__content">
          <div className="tab__contentMenu">
            <ul className="tab__contentMenu-list">
              <li>
                <button>
                  <img src={AppPics.TabGridSvg} alt="" />
                  <span className="viewsettingtitle">Grid</span>
                </button>
              </li>
              <li>
                <button>
                  <img src={AppPics.TabListSvg} alt="" />
                  <span className="viewsettingtitle">List</span>
                </button>
              </li>
              <li>
                <button>
                  <img src={AppPics.TabFilterSvg} alt="" />
                  <span className="viewsettingtitle">Filter</span>
                </button>
              </li>
            </ul>
            <div className="mainHeader__search">
              <input
                className="mainHeader__searchInput"
                placeholder="Search for something all over edpodia…"
                type="text"
              />
              <span className="mainHeader__searchBtn">
                <img src={AppPics.TopMenuSearchSvg} alt="" />
              </span>
            </div>
            <div>
              <button className="btn-left-content add">New Course</button>
            </div>
          </div>
          <div className="tab__contentBody">
            <h1 className="prime-head forSlider">Recent Courses</h1>
            <div className="slider">
              <div className="sliderBtns">
                <button className="btn-circle"></button>
              </div>
              <div className="sliderSec">
                <div className="sliderSec-box">
                  <img className="sliderSec-boxImg" src="https://picsum.photos/300/400" alt="" />
                  <div className="sliderSec-boxHead">
                    <h2>Chemistry</h2>
                  </div>
                  <div className="sliderSec-boxBtns">
                    <button className="btn-plane">Class 11</button>
                    <button className="btn-plane green">CBSE</button>
                    <img className="country_tag" src={AppPics.IndiaFlagSvg} alt="" />
                  </div>
                  <div className="sliderSec-boxMore">
                    <button className="btn-more">
                      <img src={AppPics.MoreOptPng} alt="" />
                    </button>
                    <button className="btn-right-content tool">Manage</button>
                  </div>
                </div>
                <div className="sliderSec-box">
                  <img className="sliderSec-boxImg" src="https://picsum.photos/300/400" alt="" />
                  <div className="sliderSec-boxHead">
                    <h2>Biology</h2>
                  </div>
                  <div className="sliderSec-boxBtns">
                    <button className="btn-plane">A Level</button>
                    <button className="btn-plane green">EdExcel</button>
                    <img className="country_tag" src={AppPics.UkFlagSvg} alt="" />
                  </div>
                  <div className="sliderSec-boxMore">
                    <button className="btn-more">
                      <img src={AppPics.MoreOptPng} alt="" />
                    </button>
                    <button className="btn-right-content tool">Manage</button>
                  </div>
                </div>
              </div>
              <div className="sliderBtnsRight">
                <button className="btn-circle next"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Html;
